/**
 * Created by Aleksandr on 21.12.2022
 */

const OrangeryTab = cc.Node.extend({
    ctor: function (orangery, tab) {
        this._super();

        this.tab = tab;
        this.units = {};
        this.orangery = orangery;

        const styles = cleverapps.styles.OrangeryTab;

        let height = tab.rows.length * 80;
        height = Math.min(Math.max(styles.minHeight, height), styles.maxHeight);

        const content = this.createContent(styles.width, height);

        const scroll = this.scroll = new cleverapps.UI.ScrollView(content, {
            direction: cleverapps.UI.ScrollView.DIR_BOTH,
            scrollBarEnabled: false,
            outOfBoundaryScale: false
        });
        scroll.setContentSize2(content.width, height);
        scroll.setAlignment(scroll.width / 2, scroll.height / 2);
        scroll.scrollToDefault();

        this.setAnchorPoint(0.5, 0.5);
        this.setContentSize2(scroll.width, scroll.height);

        if (this.selectedItem) {
            const point = scroll.outOfBoundariesVector(this.selectedItem);
            scroll.scrollToPoint(scroll.normalizePoint({
                x: 0,
                y: point.y
            }));

            this.selectedItem.select(true);
        }

        this.addChild(scroll);
    },

    createContent: function (width, height) {
        const styles = cleverapps.styles.OrangeryTab;
        let lines = this.tab.rows.map((row, y) => {
            const items = row.map((item, x) => {
                const view = new OrangeryItem(this.orangery, item, this.tab.id, (x + y) % 2);

                if (this.orangery.selected === item) {
                    this.selectedItem = view;
                }

                return view;
            });

            const padding = y ? styles.padding : undefined;

            return new cleverapps.GridLayout(items, {
                direction: cleverapps.UI.HORIZONTAL,
                columns: OrangeryTab.MAX_ITEMS_PER_ROW,
                padding
            });
        });

        width = lines.reduce((width, line) => Math.max(width, line.width), width);

        lines = lines.map((line) => cleverapps.UI.wrapWithPadding(line, { right: width - line.width }));

        let content = new cleverapps.Layout(lines, {
            direction: cleverapps.UI.VERTICAL
        });

        if (content.height < height) {
            content = cleverapps.UI.wrapWithPadding(content, { bottom: height - content.height });
        }

        return content;
    }
});

OrangeryTab.MAX_ITEMS_PER_ROW = 13;

cleverapps.styles.OrangeryTab = {
    padding: {
        x: 5,
        y: 5
    },
    width: 1260,
    minHeight: 320,
    maxHeight: 540
};